// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gZQ0","question":"styles_question__3OTqr","description":"styles_description__etrPB"};